<template>
  <section id="homepage">
    <navigation class="absolute"></navigation>
    <hero :words="words" :subtitle="subtitle"
          :button="{link: 'portfolio', text: 'Check out my work'}"></hero>
    <iam></iam>
    <testimonials></testimonials>
    <contact-me></contact-me>
  </section>
</template>

<script>
  import Navigation from '../components/navigation.vue';
  import Hero from '../components/hero.vue';
  import Iam from '../components/iam.vue';
  import Testimonials from '../components/testimonials.vue';
  import ContactMe from '../components/contact-me.vue';

  export default {
    components: {Navigation, Hero, Iam, Testimonials, ContactMe},
    props: {
      id: String,
      name: String,
    },

    data () {
      return {
        words: ['Creative', 'Unique', 'Innovative'],
        subtitle: 'Web and Print Designer',
      }
    },
  }
</script>

<style lang="scss">
  @import "../../css/main.scss";
</style>


// WEBPACK FOOTER //
// homepage.vue?72a171ca